import { Routes, Route } from "react-router-dom";
import withAuth from "./utils/withAuth";

import Dashboard from "./Pages/Dashboard";
import Login from "./Pages/Login";
import ResetPassword from "./Pages/ResetPassword";
import PublicRoute from "./utils/PublicRoute";

function App() {
  const ProtectedDashboard = withAuth(Dashboard);

  return (
    <Routes>
      {/* Public pages but block if token exists */}
      <Route
        path="/login"
        element={
          <PublicRoute>
            <Login />
          </PublicRoute>
        }
      />
      <Route
        path="/reset-password"
        element={
          <PublicRoute>
            <ResetPassword />
          </PublicRoute>
        }
      />

      {/* Protected page (needs token) */}
      <Route path="/" element={<ProtectedDashboard />} />
    </Routes>
  );
}

export default App;
